import {DtoMapper} from '@wemogy/reactbase';
import { IMarkerCode } from '../../../ui/wrappers/formBuilder/dataLayer/models/MarkerCode';

export default class MarkerCodeDtoMapper extends DtoMapper<IMarkerCode, any>{

}
